import ApiResourceManager from '../ApiResourceManager';

export default class StatsManager extends ApiResourceManager {
  getStats = (params) =>
    this.request({
      method: 'GET',
      url: '/stats',
      params,
    });

  getCustomerSuccessStats = (params) =>
    this.request({
      method: 'GET',
      url: '/customer-success-stats',
      params,
    });

  getOnboardingStats = (params) =>
    this.request({
      method: 'GET',
      url: '/onboarding-stats',
      params,
    });

  getSalesTeamStats = (params) =>
    this.request({
      method: 'GET',
      url: '/sales-team-stats',
      params,
    });

  getCompanyStats = (params) =>
    this.request({
      method: 'GET',
      url: '/company-stats',
      params,
    });

  getLoyaltyStats = () =>
    this.request({
      method: 'GET',
      url: '/loyalty-app-stats',
    });
}
